import type {
  ModerationFlagCategory,
  ModerationFlagSeverity,
  ModerationFlagViolationType,
} from '../moderation'

export const FILTER_TYPES = ['word', 'regex', 'substring'] as const

export type FilterType = (typeof FILTER_TYPES)[number]

export type ContentFilter = {
  filterType: FilterType
  filter: string
  description: string | null
  severity: ModerationFlagSeverity
  category: ModerationFlagCategory
  violationType: ModerationFlagViolationType
}
